import React, { useEffect } from "react";
import { exploreDroneData } from "../common/Helper";
import { useDispatch, useSelector } from "react-redux";
import { getDroneCategory } from "../../redux/slice/droneCategorySlice";
import { useNavigate } from "react-router-dom";
 
const DroneCategorie = () => {
  const { droneCategory } = useSelector((state) => state.droneCategory);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDroneCategory(1));
  }, []);
  const navigate = useNavigate();
  return (
    <>
      <style>
  {`
    .img-hover-effect {
      transition: all 0.3s ease;
    }

    .img-hover-effect:hover {
      transform: scale(1.05);
      box-shadow: 0 6px 20px rgba(50, 140, 205, 0.25);
    }

    /* External class for category card */
    .category-card {
      border-radius: 10px;
      padding: 10px;
      transition: all 0.3s ease;
    }

    .category-card:hover {
      box-shadow: 0 6px 20px rgba(50, 140, 205, 0.2);
      transform: translateY(-3px);
    }
  `}
</style>

 
      <div className="py-5" >
        <div className="container">
          <h3 className="fs_43 ff_inter fw-bold color_darkgray text-center">
            Drone <span className="" style={{ color: "#328CCD" }}>Classification</span>
          </h3>
          <div className="row pb-md-4 justify-content-between">
            {droneCategory.map((item, index) => {
              return (
                <a
                  href="#drones"
                  onClick={() => navigate(`/product/${item._id}`)}
                  key={index}
                  className="col-lg-3 cursor_pointer col-sm-4 mt-4 col-6 text-center"
                >
                  <div
    className="category-card"
    style={{
      border: "2px solid #328CCD"
    }}
  >
                    <img
                      height={200}
                      className="mx-auto w-100 object-fit-cover w_xsm_full rounded-none img-hover-effect"
                      src={item.image}
                      alt="drone image"
                    />
                    <p className="fs_15 fw-bold ff_inter color_darkgray mb-0 mt-3">
                      {item.name}
                    </p>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
 
};
 
export default DroneCategorie;